export const ListPricingPlatformFee = 44;
export const ListPricingPlatformFeeFromValue = 49; // lowest out of them all
export const ListPricingPlatformFeeFromValueRingCentral = 49;
export const ListPricingPlatformFeeFromValueSlackOrTeams = 54;

export const ListPricingUserRingCentral = 2;
export const ListPricingUserSlackOrTeams = 3;
export const ListPricingUserEmail = 4;
